const initialState = {
  fetched: false,
  id_author: 0
};

const lesson = (state: any = initialState, action: any) => {
  switch (action.type) {
    case 'CLEAN_LESSON':
      return initialState;
    case 'RECEIVE_LESSON':
      const chats = action.lesson.chats || {};
      return {
        ...state,
        ...action.lesson,
        chats: {
          ...chats,
          hasjivochat: !!JSON.parse(chats.hasjivochat || null),
          haszopimchat: !!JSON.parse(chats.haszopimchat || null),
          hastawktochat: !!JSON.parse(chats.hastawktochat || null),
          haszendeskchat: !!JSON.parse(chats.haszendeskchat || null),
          haslivechat: !!JSON.parse(chats.haslivechat || null),
          haschatroll: !!JSON.parse(chats.haschatroll || null)
        }
      };
    case 'RECEIVE_LESSON_ERROR':
      return {
        ...state,
        error: action.error
      };
    case 'RECEIVE_LESSON_FILE':
      return {
        ...state,
        urlFile: action.urlFile
      };
    case 'RECEIVE_AUDIO_FILE':
      return {
        ...state,
        contents:
          state.contents &&
          state.contents.map((content: any) => {
            if (content.id === action.lessonContentId) {
              content.embed = action.audioFile;
              return content;
            }
            return content;
          })
      };
    case 'RECEIVE_AUDIO_FILE_ERROR':
      return {
        ...state,
        contents:
          state.contents &&
          state.contents.map((content: any) => {
            if (content.id === action.lessonContentId) {
              delete content.embed;
            }
            return content;
          })
      };
    case 'RECEIVE_AUTHOR':
      return {
        ...state,
        id_author: action.author.id
      };
    case 'UPDATE_WATCHED_LESSON':
      return {
        ...state,
        watched: action.data
      };
    case 'CHANGE_LESSON_FIELD':
      return {
        ...state,
        [action.field]: action.value
      };
    case 'ADD_LESSON_FILES': {
      const files = [...action.files].map(file => ({
        front_id: action.frontId,
        title: file.name,
        size: file.size,
        mimetype: file.type.substring(file.type.indexOf('/') + 1),
        progress: 0
      }));

      return {
        ...state,
        lesson_files: [...state.lesson_files, ...files]
      };
    }
    case 'REMOVE_LESSON_FILE':
      return {
        ...state,
        lesson_files: state.lesson_files.filter((file: any, i: number) => action.index !== i)
      };
    case 'UPLOAD_LESSON_FILE_PROGRESS': {
      const files = [...state.lesson_files];

      files[action.fileIndex].progress = (action.progressEvent.loaded / action.progressEvent.total) * 100;

      return {
        ...state,
        lesson_files: files
      };
    }
    default:
      return state;
  }
};

export default lesson;
